module.exports = __webpack_public_path__ + "static/img/ginger_pictgrid13_500x366.b6cfc4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ginger_pictgrid13_500x366.jpg
// module id = 2xvr
// module chunks = 0